'use strict';

import angular from 'angular';
import './videotheque.routes';
import './videotheque.controller';
import './videotheque.css';

export default angular.module('observatoireApp.videotheque', []);
